<template>
  <section
    class="border-b border-gray-200 lg:p-12 lg:pr-0 md:p-12 md:pr-0 px-6 py-5"
    v-if="items.length > 0"
  >  
    <div class="mb-6 border-b border-gray-300 pb-[1.07rem] !text-ash-200">
      <div class="flex items-center space-x-2">
        <Icon icon="newspaper" />
        <Heading :level="4"
          class="font-medium leading-[110%] tracking-[-0.036rem]"
          color="text-ash-200"
        >
          {{ heading ?? 'Articles and Videos' }}
        </Heading>
      </div>
    </div>

    <ul class="space-y-3">
      <li
        v-for="(item, index) in items"
        :key="item.url"
        class="flex items-start space-x-2 mb-[1.07rem] last:mb-0"
      >
        <NuxtLink :to="item.url ?? ''" :aria-label="item.title" :title="item.title" :id="`article-title-${index + 1}`" class="hover:text-gold-100 text-ash-500 flex-1" external>
          {{ item.title }}
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import Heading from '../../../atom/heading.vue'
import Icon from '../../../atom/icon.vue'
import type { Article } from '~~/shared/types/common'

defineProps<{
  heading?: string
  items: Article[]
}>()
</script>
